<template>
  <transition>
    <div class="sa-f-up-attach">
      <div v-if="pflag && !loader" class="sa-f-up-att" :ref="valueadded">
        <span v-if="filesList.length > 0">{{ filesList.length }}</span>
        <span v-else>No attachements</span>
        <input
          type="file"
          ref="file"
          @change="onFileChange"
          @input-file="(x, y, z) => inputFile(x, y, z)"
          class="sa-d-none"
          name="multiplefileupload"
          :data="{ uploadtype: 'profilepic' }"
          post-action="https://imgpre.litedev.com/upload"
          id="multiplefileupload"
        />
        <span class="sa-profile-at-cnt">
          &nbsp;
          <!--Attachment-->
        </span>
        <a class="sa-id-card-up" @click="selectFile" v-if="!loader">
          <i class="icon-attachment"></i>
          <span>Upload</span>
        </a>
      </div>
      <div v-if="!pflag">
        <span v-if="filesList.length == 0">No attachements</span>
      </div>
      <div
        :v-if="filesList.length > 0"
        class="sa-d-f-a-center sa-mt10 sa-attmob"
        v-for="(filedata, index) in filesList"
        :key="index"
      >
        <a
          target="_blank"
          :href="filedata.url"
          class="sa-f-up-info"
          v-if="isImage(filedata.name)"
        >
          <img :src="filedata.url" alt />
        </a>
        <a
          target="_blank"
          :href="filedata.url"
          download
          class="sa-f-up-info"
          v-else
        >
          <i :class="attachAddTreatIcons(filedata.name)"></i>
        </a>
        <a
          target="_blank"
          :href="filedata.url"
          class="sa-ellipsis sa-text-underline"
          v-if="filedata.url"
          >{{ filedata.name }}</a
        >
        <a
          class="sa-black-text sa-edit"
          @click="removeFile(index)"
          v-if="filedata.url && pflag"
        >
          <i class="icon-delete1"></i>
        </a>
      </div>
      <img
        src="../../assets/img/loader.svg"
        alt="loader"
        class="sa-multi-loader"
        v-if="loader"
      />
    </div>
  </transition>
</template>
<script>
import axios from "axios";
import _ from "lodash";

export default {
  props: ["fileData", "pflag"],
  data() {
    return {
      imageFormat: [
        "jpg",
        "jpeg",
        "png",
        "gif",
        "bmp",
        "tif",
        "tiff",
        "eps",
        "raw",
        "cr2",
        "nef",
        "orf",
        "sr2",
        "PSD",
        "XCF",
        "AI",
        "CDR",
      ],
      icon_addTreat: null,
      file: "",
      fileName: "",
      filesList: [],
      loader: false,
      valueadded: 0,
    };
  },
  mounted() {
    let _self = this;
    _self.filesList = _self.fileData;
  },
  methods: {
    attachAddTreatIcons(fileName) {
      let fileType = fileName.split(".")[1];
      return "icon-" + fileType;
    },
    isImage(fileName) {
      let fileType = fileName.split(".")[1];
      if (this.imageFormat.includes(fileType)) {
        return true;
      }
      return false;
    },
    selectFile() {
      this.$refs.file.click();
    },
    inputFile(newFile, oldFile, prevent) {
      if (
        newFile &&
        newFile.response &&
        newFile.response.data &&
        newFile.response.data[0] &&
        newFile.response.data[0].url
      ) {
      }
      this.valueadded += 1;
      if (newFile && !oldFile) {
        this.$nextTick(function () {
          this.edit = true;
        });
      }
      if (!newFile && oldFile) {
        this.edit = false;
      }
    },
    async onFileChange(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }

      this.fileName = files[0].name;
      if (this.checkExisstingData(files[0].name)) {
        this.loader = true;
        this.icon_addTreat = files[0].name.split(".")[1] || null;
        this.createImage(files[0], this.fileName);
        // this.$parent.setImg(files[0].type)
        const formData = new FormData();
        formData.append("filename", files[0]);
        formData.append("data", { uploadtype: "doc" });
        let response = await axios.post(
          "https://imgpre.litedev.com/upload",
          formData,
          { headers: { "Content-Type": "multipart/form-data" } }
        );
        if (
          response &&
          response.data &&
          response.data.data &&
          response.data.data[0] &&
          response.data.data[0].url
        ) {
          this.$emit("file-upload-success", response.data.data[0]);
          this.loader = false;
        }
      }
    },
    checkExisstingData(val) {
      if (this.filesList.length > 0) {
        let values = [];
        let data = _.map(this.filesList, function (v) {
          values.push(v.file_nme);
        });
        let value = values.includes(val);
        return !value;
      } else {
        return true;
      }
    },
    createImage(file, filename) {
      this.valueadded += 1;
      var image = new Image();
      var reader = new FileReader();

      reader.onload = (e) => {
        this.file = e.target.result;
        // this.icon_addTreat = e.name.split(".")[1] || null;
        // this.filesList.push({'name':this.fileName,'url': this.file})
        this.$emit("change", this.file);
      };
      reader.readAsDataURL(file);
    },
    removeFile(index) {
      this.valueadded += 1;
      this.filesList.splice(index, 1);
      this.file = "";
      this.fileName = "";
    },
  },
};
</script>